import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { ContentRoute } from '../_metronic/layout'
import { shallowEqual, useSelector } from 'react-redux';
import { DashboardPage } from './pages/DashboardPage'
import AdminsPage from './modules/ContentManager/admins/AdminsPage'
import EditAdminsPage from './modules/ContentManager/admins/EditAdminsPage'
import TextsPage from './modules/ContentManager/texts/TextsPage'
import EditTextsPage from './modules/ContentManager/texts/EditTextsPage'
import LanguagesPage from './modules/ContentManager/languages/LanguagesPage';
import EditLanguagesPage from './modules/ContentManager/languages/EditLanguagesPage';
import CitasPage from './modules/ContentManager/tickets/CitasPage'
import IncidenciasPage from './modules/ContentManager/tickets/IncidenciasPage'
import SugerenciasPage from './modules/ContentManager/tickets/SugerenciasPage'
import EditTicketPage from './modules/ContentManager/tickets/EditTicketPage'
import ContactPage from './modules/ContentManager/contact/ContactPage'
import EditContactPage from './modules/ContentManager/contact/EditContactPage'
import FormsPage from './modules/ContentManager/forms/FormsPage'
import EditFormPage from './modules/ContentManager/forms/EditFormPage'
import S11MapsPage from './modules/ContentManager/s11Maps/S11MapsPage'
import EditS11MapPage from './modules/ContentManager/s11Maps/EditS11MapPage'
import PushPage from './modules/ContentManager/push/PushPage'
import EditPushPage from './modules/ContentManager/push/EditPushPage'
import UsersPage from './modules/ContentManager/users/UsersPage'
import EditUserPage from './modules/ContentManager/users/EditUserPage'
import DepartmentsPage from './modules/ContentManager/departments/DepartmentsPage'
import EditDepartmentPage from './modules/ContentManager/departments/EditDepartmentPage'
import GamificationAudioguidesPage from './modules/ContentManager/gamificationAudioguides/GamificationAudioguidesPage'
import EditGamificationAudioguidePage from './modules/ContentManager/gamificationAudioguides/EditGamificationAudioguidePage'

export default function BasePage() {
	const user = useSelector((store) => store.authentication?.user, shallowEqual);
	const isAdmin = user?.role === 'admin'

	return (
		<Switch>
			{/* Redirect from root URL to /dashboard. */ }
			<Redirect exact from="/" to="/dashboard" />
			<ContentRoute path="/dashboard" component={DashboardPage} />

			{/* USERS */}
			<ContentRoute from="/admins" component={AdminsPage} />
			<ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />
			<ContentRoute from="/users" component={isAdmin ? UsersPage : DashboardPage} />
			<ContentRoute from="/edit-user/:id?" component={isAdmin ? EditUserPage : DashboardPage} />

			{/* CIVIC */}
			<ContentRoute from="/citas" component={isAdmin ? CitasPage : DashboardPage} />
			<ContentRoute from="/edit-cita/:id?" component={isAdmin ? EditTicketPage : DashboardPage} />
			<ContentRoute from="/incidencias" component={isAdmin ? IncidenciasPage : DashboardPage} />
			<ContentRoute from="/edit-incidencia/:id?" component={isAdmin ? EditTicketPage : DashboardPage} />
			<ContentRoute from="/sugerencias" component={isAdmin ? SugerenciasPage : DashboardPage} />
			<ContentRoute from="/edit-sugerencia/:id?" component={isAdmin ? EditTicketPage : DashboardPage} />
			<Redirect from="/tickets" to="/incidencias" />
			<Redirect from="/edit-ticket/:id" to="/edit-incidencia/:id" />
			<ContentRoute from="/contact" component={isAdmin ? ContactPage : DashboardPage} />
			<ContentRoute from="/edit-contact/:id?" component={isAdmin ? EditContactPage : DashboardPage} />
			<ContentRoute from="/forms" component={isAdmin ? FormsPage : DashboardPage} />
			<ContentRoute from="/edit-form/:id?" component={isAdmin ? EditFormPage : DashboardPage} />
			<ContentRoute from="/s11-maps" component={isAdmin ? S11MapsPage : DashboardPage} />
			<ContentRoute from="/edit-s11-map/:key" component={isAdmin ? EditS11MapPage : DashboardPage} />
			<ContentRoute from="/departments" component={isAdmin ? DepartmentsPage : DashboardPage} />
			<ContentRoute from="/edit-department/:id?" component={isAdmin ? EditDepartmentPage : DashboardPage} />
			<ContentRoute from="/push" component={isAdmin ? PushPage : DashboardPage} />
			<ContentRoute from="/edit-push/:id?" component={isAdmin ? EditPushPage : DashboardPage} />
			<ContentRoute from="/gamification-audioguides" component={isAdmin ? GamificationAudioguidesPage : DashboardPage} />
			<ContentRoute from="/edit-gamification-audioguide/:id?" component={isAdmin ? EditGamificationAudioguidePage : DashboardPage} />

			{/* MISCELLANY */}
			<ContentRoute from='/languages' component={!isAdmin ? DashboardPage : LanguagesPage}/>
			<ContentRoute from='/edit-language/:id?' component={!isAdmin ? DashboardPage : EditLanguagesPage}/>
			<ContentRoute from="/texts" component={!isAdmin ? DashboardPage : TextsPage} />
			<ContentRoute from="/edit-text/:id" component={!isAdmin ? DashboardPage : EditTextsPage} />

			<Redirect to="/error" />
		</Switch>
	)
}
